import { COLOR_WHITE_LIST } from '../constants';

export const isColorWhiteListed = (color: string): color is 'primary' | 'secondary' | 'info' | 'error' =>
  COLOR_WHITE_LIST.includes(color);
